import { defineComponent } from 'vue'
import { BlockModule } from '@/website/blocks/common'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

new BlockModule({
    selector: '.block-steps-section',
    vueComponent: defineComponent({
        components: {
            Tabs,
            TabsContent,
            TabsList,
            TabsTrigger,
        },
        setup() {},
    }),
})
